import React, { useState, useEffect } from 'react';
import utnFrcLogo from '../assets/logos/utnFrcLogo.png';
import logoAve from '../assets/logos/logoave.png';
import './SubjectCardsGrid.css';

const SubjectCardsGrid = () => {
  const [expandedSections, setExpandedSections] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [selectedUrl, setSelectedUrl] = useState('');
  const [selectedSubject, setSelectedSubject] = useState('');

  useEffect(() => {
    console.log('Estado del modal cambió:', { showModal, selectedUrl, selectedSubject });
  }, [showModal, selectedUrl, selectedSubject]);

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const handleSubjectClick = (e, url, subjectName) => {
    e.preventDefault();
    e.stopPropagation();
    console.log('Click detectado:', { url, subjectName });
    
    if (!url) {
      alert('URL no definida para esta materia');
      return;
    }
    
    console.log('Antes de setear estados...');
    setSelectedUrl(url);
    setSelectedSubject(subjectName);
    setShowModal(true);
    console.log('Estados seteados. showModal debería ser true');
  };

  const handleConfirm = () => {
    console.log('Confirmando navegación a:', selectedUrl);
    if (selectedUrl) {
      window.open(selectedUrl, '_blank', 'noopener,noreferrer');
    } else {
      console.error('No hay URL seleccionada');
    }
    setShowModal(false);
    setSelectedUrl('');
    setSelectedSubject('');
  };

  const handleCancel = () => {
    console.log('Cancelando navegación');
    setShowModal(false);
    setSelectedUrl('');
    setSelectedSubject('');
  };

  const subjects = {
    '1er Año': {
      color: 'primary',
      icon: '🎯',
      subjects: [
        { name: 'Lógica y Estructuras Discretas (LED)', url: process.env.REACT_APP_1ER_ANIO_LED },
        { name: 'Sistemas y Procesos de Negocio (SPN)', url: process.env.REACT_APP_1ER_ANIO_SPN },
        { name: 'Algoritmos y Estructuras de Datos', url: process.env.REACT_APP_1ER_ANIO_ALGORITMOS },
        { name: 'Arquitectura de Computadoras', url: process.env.REACT_APP_1ER_ANIO_ARQUITECTURA }
      ]
    },
    '2do Año': {
      color: 'success',
      icon: '🚀',
      subjects: [
      { name: 'Análisis de Sistemas de Información', url: process.env.REACT_APP_2DO_ANIO_ANALISIS_DE_SISTEMAS_DE_INFORMACION },
        { name: 'Paradigmas de Programación', url: process.env.REACT_APP_2DO_ANIO_PARADIGMAS_DE_PROGRAMACION },
        { name: 'Probabilidades y Estadísticas', url: process.env.REACT_APP_2DO_ANIO_PROBABILIDADES_Y_ESTADISTICAS },
        { name: 'Sintaxis y Semántica de los Lenguajes', url: process.env.REACT_APP_2DO_ANIO_SINTAXIS_Y_SEMANTICA_DE_LOS_LENGUAJES },
        { name: 'Sistemas Operativos', url: process.env.REACT_APP_2DO_ANIO_SISTEMAS_OPERATIVOS   }
      ]
    },
    '3er Año': {
      color: 'warning',
      icon: '⚡',
      subjects: [
        { name: 'Análisis Numérico', url: process.env.REACT_APP_3ER_ANIO_ANALISIS_NUMERICOS },
        { name: 'Backend de Aplicaciones', url: process.env.REACT_APP_3ER_ANIO_BACKEND_DE_APLICACIONES },
        { name: 'Bases de Datos', url: process.env.REACT_APP_3ER_ANIO_BASES_DE_DATOS },
        { name: 'Comunicación de Datos', url: process.env.REACT_APP_3ER_ANIO_COMUNICACION_DE_DATOS },
        { name: 'Desarrollo de software', url: process.env.REACT_APP_3ER_ANIO_DESARROLLO_DE_SOFTWARE },
        { name: 'Diseño de Sistemas de Información', url: process.env.REACT_APP_3ER_ANIO_DISENIO_DE_SISTEMAS_DE_INFORMACION },
        { name: 'Seminario Integrador', url: process.env.REACT_APP_3ER_ANIO_SEMINARIO_INTEGRADOR }
      ]
    },
    '4to Año': {
      color: 'info',
      icon: '💼',
      subjects: [
        { name: 'Administración de Sistemas de Información', url: process.env.REACT_APP_4TO_ANIO_ADMINISTRACION_DE_SISTEMAS_DE_INFORMACION },
        { name: 'Ingeniería y Calidad de Software', url: process.env.REACT_APP_4TO_ANIO_INGENIERIA_Y_CALIDAD_DE_SOFTWARE },
        { name: 'Investigación Operativa', url: process.env.REACT_APP_4TO_ANIO_INVESTIGACION_OPERATIVA },
        { name: 'Redes de Datos', url: process.env.REACT_APP_4TO_ANIO_REDES_DE_DATOS },
        { name: 'Simulación', url: process.env.REACT_APP_4TO_ANIO_SIMULACION },
        { name: 'Tecnologías para la Automatización', url: process.env.REACT_APP_4TO_ANIO_TECNOLOGIAS_PARA_LA_AUTOMATIZACION }
      ]
    },
    '5to Año': {
      color: 'danger',
      icon: '🎓',
      subjects: [
        { name: 'Ciencia de Datos', url: process.env.REACT_APP_5TO_ANIO_CIENCIA_DE_DATOS },
        { name: 'Gestión Gerencial', url: process.env.REACT_APP_5TO_ANIO_GESTION_GERENCIAL },
        { name: 'Inteligencia Artificial', url: process.env.REACT_APP_5TO_ANIO_INTELIGENCIA_ARTIFICIAL },
        { name: 'Proyecto Final', url: process.env.REACT_APP_5TO_ANIO_PROYECTO_FINAL },
        { name: 'Seguridad de Los Sistemas de Información', url: process.env.REACT_APP_5TO_ANIO_SEGURIDAD_EN_LOS_SISTEMAS_DE_INFORMACION },
        { name: 'Sistema de Gestión', url: process.env.REACT_APP_5TO_ANIO_SISTEMA_DE_GESTION }
      ]
    },
    'Materias Electivas': {
      color: 'secondary',
      icon: '🔬',
      subjects: [
        { name: 'Backend de Aplicaciones', url: process.env.REACT_APP_ELECTIVA_BACKEND_DE_APLICACIONES },
        { name: 'Com. Multimedial en El Desarrollo de Sist. de Información', url: process.env.REACT_APP_ELECTIVA_COMUNICACIONES_MULTIMEDIAL },
        { name: 'Desarrollo de Aplicaciones con Objetos', url: process.env.REACT_APP_ELECTIVA_DESARROLLO_DE_APLICACIONES_CON_OBJETOS },
        { name: 'Desarrollo y Operaciones DevOps', url: process.env.REACT_APP_ELECTIVA_DESARROLLO_Y_OPERACIONES_DEVOPS },
        { name: 'Gestión de la Mejora de los Procesos', url: process.env.REACT_APP_ELECTIVA_GESTION_DE_LA_MEJORA_DE_PROCESOS },
        { name: 'Gestión Industrial de la Producción', url: process.env.REACT_APP_ELECTIVA_GESTION_INDUSTRIAL_DE_LA_PRODUCCION },
        { name: 'Green Software', url: process.env.REACT_APP_ELECTIVA_GREEN_SOFTWARE },
        { name: 'Consultoria en Negocios Digitales', url: process.env.REACT_APP_ELECTIVA_CONSULTORIA_EN_NEGOCIOS_DIGITALES },
        { name: 'Creatividad e Innovación en Ingeniería', url: process.env.REACT_APP_ELECTIVA_CREATIVIDAD_E_INNOVACION_EN_INGENIERIA },
        { name: 'Decisiones en Escenarios Complejos', url: process.env.REACT_APP_ELECTIVA_DECISIONES_EN_ESCENARIOS_COMPLEJOS },
        { name: 'Emprendimientos Tecnológicos', url: process.env.REACT_APP_ELECTIVA_EMPRENDIMIENTOS_TECNOLOGICOS },
        { name: 'Ingeniería de Soft. de Fuentes Abiertas/Libres', url: process.env.REACT_APP_ELECTIVA_INGENIERIA_DE_SOFT_DE_FUENTES_ABIERTAS },
        { name: 'Integración de Aplicaciones en Entorno Web', url: process.env.REACT_APP_ELECTIVA_INTEGRACION_DE_APLICACIONES_EN_ENTORNO_WEB },
        { name: 'Testing de Software', url: process.env.REACT_APP_ELECTIVA_TESTING_DE_SOFTWARE }
      ]
    },
    'Departamento Ing. en Sistemas': {
      color: 'dark',
      icon: '🏛️',
      subjects: [
        { name: 'Portal Principal', url: process.env.REACT_APP_DPTO_PORTAL_PRINCIPAL },
        { name: 'Noticias', url: process.env.REACT_APP_DPTO_NOTICIAS },
        { name: 'Investigación', url: process.env.REACT_APP_DPTO_INVESTIGACION },
        { name: 'Extensión', url: process.env.REACT_APP_DPTO_EXTENSION },
        { name: 'Contacto', url: process.env.REACT_APP_DPTO_CONTACTO }
      ]
    }
  };

  return (
    <div className="subject-cards-container">
      {/* Header con logo */}
      <div className="header-section">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 text-center">
              <div className="logo-container mb-4">
                <img 
                  src={utnFrcLogo} 
                  alt="UTN FRC Logo" 
                  className="utn-logo"
                />
                <img 
                  src={logoAve} 
                  alt="Logo Ave" 
                  className="ave-logo"
                />
              </div>
              <h1 className="main-title">
                <span className="title-gradient">Departamento de Ing. En Sistemas de Información</span>
              </h1>
              <h2 className="subtitle">Universidad Tecnológica Nacional - Facultad Regional Córdoba</h2>
              <div className="decorative-line mx-auto"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Grid de cards */}
      <div className="container my-5">
        <div className="row g-4">
          {Object.entries(subjects).map(([yearName, yearData]) => (
            <div key={yearName} className="col-12 col-md-6 col-lg-4">
              <div className={`card subject-card border-${yearData.color} h-100`}>
                <div className={`card-header bg-${yearData.color} text-white`}>
                  <h5 className="card-title mb-0 d-flex align-items-center">
                    <span className="me-2 fs-4">{yearData.icon}</span>
                    {yearName}
                  </h5>
                </div>
                <div className="card-body">
                  <button
                    className={`btn btn-outline-${yearData.color} w-100 mb-3`}
                    onClick={() => toggleSection(yearName)}
                    aria-expanded={expandedSections[yearName]}
                  >
                    {expandedSections[yearName] ? 'Ocultar Enlaces' : 'Ver Enlaces'}
                    <i className={`ms-2 fas fa-chevron-${expandedSections[yearName] ? 'up' : 'down'}`}></i>
                  </button>
                  
                  <div className={`collapse ${expandedSections[yearName] ? 'show' : ''}`}>
                    <div className="links-container">
                      {yearData.subjects.map((subject, index) => (
                        <div key={index} className="subject-link-item mb-2">
                          <button
                            onClick={(e) => handleSubjectClick(e, subject.url, subject.name)}
                            className={`btn btn-sm btn-outline-${yearData.color} w-100 text-start`}
                            type="button"
                          >
                            <i className="fas fa-external-link-alt me-2"></i>
                            {subject.name}
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <footer className="footer-section mt-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <p className="footer-text">
                © 2025 UTN FRC - Departamento de Ingeniería en Sistemas de Información
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Modal de Advertencia */}
      {console.log('Renderizando... showModal:', showModal)}
      {showModal && (
        <div 
          style={{ 
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
          }}
          onClick={handleCancel}
        >
          <div 
            style={{
              backgroundColor: 'white',
              padding: '2rem',
              borderRadius: '15px',
              maxWidth: '600px',
              width: '90%',
              boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⚠️</div>
              <h2 style={{ color: '#e17055', marginBottom: '1rem' }}>IMPORTANTE</h2>
            </div>
            
            <div style={{ marginBottom: '1.5rem' }}>
              <p style={{ marginBottom: '1rem', fontWeight: '500' }}>
                A continuación accederás al asistente de ChatGPT de la materia:
              </p>
              <p style={{ fontWeight: 'bold', color: '#007bff', fontSize: '1.2rem', marginBottom: '1rem' }}>
                📚 {selectedSubject}
              </p>
              <div style={{ 
                padding: '1rem', 
                backgroundColor: '#fff3cd', 
                borderRadius: '10px',
                borderLeft: '4px solid #ffc107',
                marginBottom: '1rem'
              }}>
                <p style={{ margin: 0, fontWeight: 'bold', textAlign: 'center' }}>
                  Las respuestas generadas por este asistente tienen carácter orientativo y deben considerarse como apoyo al proceso de aprendizaje.
                </p>
                <p style={{ margin: '0.5rem 0 0 0', fontWeight: 'bold', fontStyle: 'italic', textAlign: 'center' }}>
                  Se recomienda contrastar la información con las fuentes oficiales de la cátedra o con el equipo docente.
                </p>
              </div>
            </div>
            
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
              <button 
                onClick={handleCancel}
                style={{
                  padding: '0.75rem 1.5rem',
                  border: '2px solid #6c757d',
                  backgroundColor: 'transparent',
                  color: '#6c757d',
                  borderRadius: '25px',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
              >
                ❌ Cancelar
              </button>
              <button 
                onClick={handleConfirm}
                style={{
                  padding: '0.75rem 1.5rem',
                  border: 'none',
                  backgroundColor: '#ffc107',
                  color: 'white',
                  borderRadius: '25px',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
              >
                ✅ Entendido, Continuar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubjectCardsGrid;
